import { createStyles, makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionContainer: {
      margin: '15px 0 5px 0',
      width: '100%',
      padding: 20,
      backgroundColor: '#eaeaea',
      boxShadow: theme.shadows[2],
      borderRadius: 3,
    },
    label: {
      marginTop: 5,
      fontFamily: 'Roboto',
      fontSize: 14,
      alignSelf: 'start',
      color: '#000000',
    },
    input: {
      marginTop: 10,
      marginBottom: 10,
      height: 40,
      width: '100%',
      border: '1px solid #ccc',
      backgroundColor: 'white',
      overflow: 'hidden',
      borderRadius: 4,
      padding: 10.5,
      boxSizing: 'border-box',
      '&:hover': {
        borderColor: 'black',
      },
      '&:focus': {
        border: '1.5px solid #3f51b5',
      },
    },
    errorIput: {
      border: '1px solid red',
      '&:hover': {
        borderColor: 'red',
      },
      '&:focus': {
        border: '1.5px solid red',
      },
    },
    select: {
      marginTop: 10,
      marginBottom: 10,
      height: 40,
      width: '100%',
      backgroundColor: 'white',
      '& div': {
        '&:focus': {
          backgroundColor: 'transparent',
        },
      },
    },
  }),
);
